export default __webpack_public_path__ + "static/media/user-04.cb73a993.jpg";